import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { convertToRaw } from 'draft-js'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from 'components/dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import MUIRichTextEditor from 'mui-rte'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const useStyles = makeStyles(theme => ({
  editorRoot: {
    minHeight: '400px',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '0 16px',
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
}))

const EventDescription = () => {
  const { register, setValue, getValues } = useFormContext()
  const [newDescription, setNewDescription] = useState(null)

  const [isOpen, setIsOpen] = useState(false)

  const classes = useStyles()

  useEffect(() => {
    register('description')
  }, [register])

  const defaultValue = getValues('description')

  return (
    <>
      <div className={classes.editorRoot}>
        <MUIRichTextEditor
          label="Enter your offering description..."
          controls={['title', 'bold', 'italic', 'bulletList']}
          style={{ minHeight: '500px' }}
          defaultValue={defaultValue}
          onChange={value => {
            const content = JSON.stringify(
              convertToRaw(value.getCurrentContent()),
            )
            setNewDescription(content)
          }}
          onBlur={value => {
            setValue('description', newDescription)
          }}
        />
      </div>
      <Button
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        RECOMMENDED OFFERING DETAILS
      </Button>
      <RecommendedDetailsDialog isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}

const recommendationsConfig = [
  {
    id: 1,
    sectionTitle: 'Identify who the offering is for',
    bullets: [
      'Is this offering going to be for beginners or advanced golfers',
      'Is the offering child and/or family friendly?',
      'Are there age restrictions? Will alcohol be served?',
    ],
  },
  {
    id: 2,
    sectionTitle: 'Do participants need equipment',
    bullets: ['Include in your description if golf equipment is required'],
  },
  {
    id: 3,
    sectionTitle: 'What are the expectations?',
    bullets: [
      'Will participants need to be ready to go onto the golf course?',
      'How many participants wil be attendting (5 is a lot different than 50),',
      'How much 1-on-1 time will I have with the coach?',
    ],
  },
  {
    id: 4,
    sectionTitle: 'Are friends allowed to join?',
    bullets: [
      'Can participants bring friends or family?',
      'Is the offering for members of the club only?',
    ],
  },
  {
    id: 5,
    sectionTitle: "What's included?",
    bullets: [
      'Will participants receive range balls, shop discount, food and/or alcohol?',
    ],
  },
  {
    id: 6,
    sectionTitle: 'Frequently asked questions',
    bullets: [
      'Include a list of commonly asked questions',
      'Provide contact information',
    ],
  },
]

const RecommendedDetailsDialog = ({ isOpen, setIsOpen }) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  return (
    <Dialog
      fullScreen={isMobile}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      showCloseButton
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle>Recommended Offering Details</DialogTitle>
          <DialogContent style={{ padding: '0 20px 20px 20px' }}>
            {recommendationsConfig.map(({ id, sectionTitle, bullets }) => (
              <div key={id} style={{ margin: '16px' }}>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {sectionTitle}
                </Typography>
                <ul style={{ margin: 0 }}>
                  {bullets.map((listItem, i) => (
                    <li key={i}>
                      <Typography
                        variant="caption"
                        style={{ fontSize: '14px' }}
                      >
                        {listItem}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default EventDescription
